import React from 'react';

import { Tooltip } from '@mui/material';

import ExclamationOutlinedIcon from './assets/exclamation-outlined.svg';
import useStyles from './styles';

interface Props {
    title: React.ReactNode;
    href?: string;
    tooltip?: React.ReactNode;
    className?: string;
}

const Feature: React.FC<Props> = ({ title, tooltip, href, className }) => {
    const { classes, cx } = useStyles();
    const Component = href ? 'a' : 'span';
    const props = href ? { href, target: '_blank', rel: 'noopener noreferrer' } : {};
    return (
        <Tooltip title={tooltip || null}>
            <Component className={cx(classes.root, className)} {...props}>
                <span className={classes.title}>{title}</span>
                {tooltip ? <ExclamationOutlinedIcon className={classes.icon} /> : null}
            </Component>
        </Tooltip>
    );
};

export default Feature;
